import formatter from '../formatter/formatter';

const sportsResultsMap = (bet) => {
  let map;
  switch (parseInt(bet.idSport, 10)) {
    case 1:
    case 12:
    case 29:
      // Soccer, Rugby, Futsal
      map = [{
        providerId: 'HT',
      },
      {
        providerId: 'FT',
      },
      {
        providerId: 'OT',
      },
      {
        providerId: 'AP',
      },
      ];
      break;
    case 6:
      // Handball
      map = [{
        providerId: 'HT',
      },
      {
        providerId: 'FT',
      },
      {
        providerId: 'OT',
      },
      ];
      break;
    case 15:
      // Bandy
      map = [{
        providerId: 'HT',
      },
      {
        providerId: 'FT',
      },
      ];
      break;
    case 2:
    case 16:
      // Basketball, American Football
      map = [{
        providerId: '1Q',
      },
      {
        providerId: '2Q',
      },
      {
        providerId: '3Q',
      },
      {
        providerId: '4Q',
      },
      {
        providerId: 'FT',
      },
      {
        providerId: 'OT',
      },
      ];
      break;
    case 3:
    case 11:
    case 21:
    case 32:
      // Baseball, Motorsport, Cricket, Bowls
      map = [{
        providerId: 'FT',
      }];
      break;
    case 4:
    case 7:
      // Ice hockey, Floorball
      map = [{
        providerId: '1P',
      },
      {
        providerId: '2P',
      },
      {
        providerId: '3P',
      },
      {
        providerId: 'FT',
      },
      {
        providerId: 'OT',
      },
      {
        providerId: 'AP',
      },
      ];
      break;
    case 5:
    case 23:
      // Tennis, Volleyball
      map = [{
        providerId: 'Set1',
      },
      {
        providerId: 'Set2',
      },
      {
        providerId: 'Set3',
      },
      {
        providerId: 'Set4',
      },
      {
        providerId: 'Set5',
      },
      {
        providerId: 'FT',
      },
      ];
      break;
    case 31:
      // Badminton
      map = [{
        providerId: 'Set1',
      },
      {
        providerId: 'Set2',
      },
      {
        providerId: 'Set3',
      },
      {
        providerId: 'FT',
      },
      ];
      break;
    case 26:
      // Waterpolo
      map = [{
        providerId: '1Q',
      },
      {
        providerId: '2Q',
      },
      {
        providerId: '3Q',
      },
      {
        providerId: '4Q',
      },
      {
        providerId: 'FT',
      },
      {
        providerId: 'OT',
      },
      {
        providerId: 'AP',
      },
      ];
      break;
    default:
      // All others
      map = [{
        providerId: 'FT',
      }];
  }
  return map;
};

const ticketCheckMapper = (ticket) => {
  const ticketCopy = Object.assign({}, ticket);

  ticketCopy.fullResultsEnabled = true;

  ticketCopy.bets.map((bet) => {
    const betCopy = bet;

    betCopy.betOutcome.betOutcomeDisplayName = formatter.betOutcomeNameFormatter(betCopy);

    betCopy.resultsMap = sportsResultsMap(bet);

    betCopy.finalResults = betCopy.resultsMap.map(item => (
      betCopy.results.find(resItem => resItem.providerResultId === item.providerId)
    )).filter(Boolean);

    return betCopy;
  });

  return ticketCopy;
};

export default ticketCheckMapper;
